const joinLabels = (labels: string[]) => {
  if (labels.length <= 1) {
    return labels[0] || ''
  }
  if (labels.length === 2) {
    return `${labels[0]} and ${labels[1]}`
  }
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
}

export const getTopicUpdatedMessage = (...fields: string[]) => {
  const uniqueFields = [
    ...new Set(fields.map((field) => field.trim()).filter(Boolean)),
  ]
  if (uniqueFields.length === 0) {
    return 'Topic updated'
  }
  return `Topic ${joinLabels(uniqueFields)} updated`
}
